/*** IMPORTS FROM imports-loader ***/
import hydrator from "@gjensidige/views-api/src/runtime/hydrator";
import Component from ".";

/* global hydrator, Component */

// create a map of what we have hydrated, share it on window
window.__HYDRATED__ = window.__HYDRATED__ || {};

// get the current script executing
const partSrc = window.document?.currentScript?.getAttribute('src');

// filter the ones that need to be hydrated (data-nodeid contains the id for the props -> only hydration on node id's)
const parts = Array.from(
  document.querySelectorAll('script[src="' + partSrc + '"]')
).filter((part) => part.getAttribute('data-nodeid'));

// if this selection of parts contains elements that needs to be hydrated, add an eventListener
if (parts.length && window.addEventListener) {
  window.addEventListener('load', function () {
    parts.forEach((part) => {
      // make sure we only hydrate our components once
      const NODE_ID = part.getAttribute('data-nodeid');
      if (!window.__HYDRATED__[NODE_ID]) {
        window.__HYDRATED__[NODE_ID] = true;
        hydrator(Component, NODE_ID);
      }
    });
  });
}


import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types/prop-types';
import { Flex, Link, Text, Title } from '@gjensidige/builders-components';
import { ArrowRight } from '@gjensidige/builders-icons';
import { CtaBannerProps as Props } from './types';
import styles from '../less/cta-banner.module.less';

export const CtaBanner = ({
  title,
  text,
  link,
  symbol,
  backgroundColor: color = 'blue'
}: Props) => (
  <Flex
    as={Link}
    center
    className={classNames(styles.ctaBanner, styles.marginYParts, styles[color])}
    direction="column"
    fill
    gap="sm xl"
    href={link.url}
    target={link.newWindow ? '_blank' : undefined}
    tracking={{
      eventLabel: link.trackingLabel || `cta-banner-module_${link.url}`,
      eventModule: 'cta-banner-module',
      eventSource: '@gjensidige/parts-cta-banner',
      eventVersion: '1.0.0'
    }}
  >
    {!!symbol && <img alt="" src={symbol} height="159" width="163" />}
    <Flex
      align="center"
      gap="sm xl"
      layout={{ xs: 1, md: symbol || !text ? 1 : 2 }}
    >
      <Title size="4" className={styles.title} text={title} />
      {!!text && (
        <Text
          as="div"
          className={styles.htmlArea}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </Flex>
    <ArrowRight className={styles.arrowStatic} />
    <svg viewBox="0 0 60 32" className={styles.arrowAnimate}>
      <line x1="16" y1="16" x2="65" y2="16" />
      <line x1="0" y1="0" x2="16" y2="16" />
      <line x1="0" y1="32" x2="16" y2="16" />
    </svg>
  </Flex>
);

CtaBanner.CSR = true;
CtaBanner.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  link: PropTypes.object.isRequired,
  symbol: PropTypes.string,
  backgroundColor: PropTypes.string
};

export default CtaBanner;
